import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import { styled } from '@material-ui/core/styles';
import { Member } from 'twilio-chat/lib/member';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    purple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
    },
}));

const ScrollContainer = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('xs')]: {
        display: 'flex',
    },
}));

interface ChatParticipantsProps {
    members: [];
}

export default function ChatParticipantStrip(props: ChatParticipantsProps) {
    const classes = useStyles();

    return (
            <ScrollContainer>
                {props.members.map((member: Member) => (
                    <Avatar className={classes.purple}>{member.identity.substring(0, 2).toUpperCase()}</Avatar>
                ))}
            </ScrollContainer>
    );
}
